// extracted by mini-css-extract-plugin
export var definition = "Expander-module--definition--c1a17";
export var expanded = "Expander-module--expanded--058cb";
export var root = "Expander-module--root--3e5c1";
export var term = "Expander-module--term--07793";